<template lang="html">
    <div>
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>

        <form @submit.prevent="addClient">
            <div class="form-group">
              <label for="name">Client Name</label>
              <input type="text" class="form-control" name="name" v-model="form.name" placeholder="A Fortune 500 Co">
            </div>
            <div class="form-group">
              <label for="email">Client Email</label>
              <input type="text" class="form-control" name="email" v-model="form.email" placeholder="client@foundsm.com">
            </div>
            <div class="form-group">
              <label for="url">Client URL</label>
              <input type="text" class="form-control" name="url" v-model="form.url" placeholder="http://www.client-url.com/">
            </div>
            <div class="form-group">
              <label for="budget">Monthly Budget</label>
              <input type="text" class="form-control" name="budget" v-model="form.budget" placeholder="100000.00">
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                    Add Client
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                errors: {},
                email: '',
                url: '',
                name: '',
                budget: '',
            },
            loading: false
        }
    },

    computed: {
        formErrors() {
            return Object.keys(this.form.errors).length > 0;
        }
    },

    methods: {
        addClient() {
            this.loading = true;
            let form = this.form;
            form.budget = form.budget.replace(/\$|,/g,'');
            this.$store.dispatch(`client/addClient`, {
                form: form
            }).then(response => {
                    Bus.$emit('show-success-alert', response.message);
                    Bus.$emit('client-added', response.client);
                    this.reset();
                })
                .catch(response => {
                    this.form.errors = response.data.errors;
                    this.loading = false;
                });
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewClientForm.vue